import { StageTrigger } from '@templates/index';
import { useTransportStore, useUiStore } from '@store/index';

/**
 * Floating "BEAT" trigger. Doubles as a recording-status indicator —
 * tints red whenever a recording is in progress so the player can see
 * the state from the stage even with the drawer closed.
 */
export function TransportTrigger() {
  const setOpen = useUiStore((s) => s.setTransportOpen);
  const recording = useTransportStore((s) => s.recording);
  const metronomeOn = useTransportStore((s) => s.metronomeOn);
  const label = recording ? 'REC' : 'BEAT';
  return (
    <StageTrigger
      label={label}
      offsetLeft={264}
      onClick={() => setOpen(true)}
      active={recording || metronomeOn}
    />
  );
}
